import { secureStorageUtils } from './secureStorageUtils';
import toast from 'react-hot-toast';

export const logout = (showToast: boolean = true) => {
  // Clear all auth-related data
  secureStorageUtils.removeItem("access-token");
  secureStorageUtils.removeItem("userData");
  localStorage.removeItem("hasFetchedUser");
  localStorage.removeItem("ngl-registration-data");
  localStorage.removeItem("register-payload");
  localStorage.removeItem("profileImage");
  
  // Clear any other cached data
  localStorage.clear();
  
  if (showToast) {
    toast.error("Session expired. Please log in again.");
  }
  
  console.log("User logged out - all auth data cleared");
};

export const isAuthenticated = (): boolean => {
  const token = secureStorageUtils.getItem("access-token");
  return !!token;
}; 